export default {
      id: "icon-menottes-usage",
      viewBox: "0 0 191.1 89.4",
      url: __webpack_public_path__ + "icons.svg#icon-menottes",
      toString: function () {
        return this.url;
      }
    }